import React from 'react'
import PropTypes from 'prop-types'
import UserItemImage from './UserItemImage'

import './style.css.scss'

const UserItem = ({
  user,
  currentUserId,
  selected,
  children,
  onClick
}) => {
  const childrenWithProps = React.Children.toArray(children, child => {
      React.cloneElement(child, { user })
    }
  )

  return (
    <section className={`user-item ${selected ? 'selected' : ''}`}
      onClick={onClick}>
      <UserItemImage user={user}/>
      <div className="user-info">
        <div className="user-name">
          {user.name}
          <span className="current-user">
            {user.id && user.id == currentUserId ? "(You)" : ""}
          </span>
        </div>
        <div className="user-email">{user.email}</div>
      </div>
      <div className="actions">
        {childrenWithProps}
      </div>
    </section>
  )
}

UserItem.propTypes = {
  user: PropTypes.object,
  currentUserId: PropTypes.number,
  selected: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func
}

UserItem.defaultProps = {
  user: {}
}

export default UserItem